let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5O1mG")).then(() => parcelRequire('4y3Yq'));